import {requestContext} from '../../../../../../common/requestContext';
import {PartialFrameElements} from '../type/PartialFrameElements.interface';

/**
 * ContentElement 내 이미지에 기능을 추가하는 함수
 *
 * 이미지를 클릭했을 때 동작, 드래그 막기 등을 적용합니다.
 * frameElements가 DOM에 붙은 이후에 불러야합니다.
 */
export function applyImageFeaturesInContentElement({
  frameElements,
  onClickImage,
}: {
  frameElements: PartialFrameElements;
  onClickImage?: (element: HTMLImageElement | SVGSVGElement) => void;
}) {
  const {contentElement} = frameElements;

  const imgElements: NodeListOf<HTMLImageElement | SVGSVGElement> =
    contentElement.querySelectorAll('img, svg');
  for (const imgElement of imgElements) {
    if (imgElement instanceof HTMLImageElement) {
      imgElement.draggable = false;
    }

    const isLoadingImageErrorImg =
      imgElement.getAttribute('data-is-loading-image-error') === 'true';
    const isMobile = requestContext.requestInfo.display.isMobile;
    const isCover = imgElement.getAttribute('data-is-cover') === 'true';
    if (onClickImage && !isLoadingImageErrorImg && (!isMobile || !isCover)) {
      imgElement.classList.add('tv-zoom');
      imgElement.onclick = event => {
        onClickImage(event.currentTarget as HTMLImageElement | SVGSVGElement);
      };
    }
    if (isCover) {
      // epub 에 height 가 명시된 경우 safari 에서 max-width 보다 우선해 height 가 늘어나면서 화면을 벗어나는 현상이 있습니다. 이러한 현상이 발생하더라도 화면은 벗어나게 하지 않기 위해 max-height 를 100vh 로 설정합니다.
      imgElement.style.maxHeight = '100vh';
    }
  }
}
